import Image from "next/image";

export default function Trusted() {
  return (
    <div className=" py-2 pb-2">
      <div className="mx-auto max-w-2xl px-6 lg:px-8">
        <h3 className="text-center text-sm pt-10 font-thin  ">
          Good Standing CRA. P.App Member of Appraisal Institute of Canada, Real
          Estate Broker Member of Reco and Toronto Regional Real Estate Board.
        </h3>
        <div className="mx-auto pt-5 px-5 grid max-w-3xl grid-cols-2 items-center justify-evenly gap-x-8 gap-y-10  lg:grid-cols-2">
          <Image
            className=" w-full  h-16  object-contain "
            src="/aic-logo.webp"
            alt="AIC Appraisal Institute of Canada"
            width={150}
            height={100}
          />
          <Image
            className="  w-full h-10  object-contain"
            src="/toronto.png"
            alt="TREB Toronto Real Estate Board Logo"
            width={150}
            height={100}
          />
        </div>
      </div>
    </div>
  );
}
